import { siteConfig } from "@/components/homepage/_config"
import { CornerPlus } from "@/components/ui/corner-plus"
import { DitherDivider } from "@/components/homepage/animations/lazy-dither"
import { IntegrationBlock } from "@/components/homepage/animations/sections/integration-block"
import { AgentWorkflowBlock } from "@/components/homepage/animations/sections/agent-workflow-block"

const workflowConnectConfig = siteConfig.workflowConnectSection

export function WorkflowConnect() {
    return (
        <section id="workflow-connect" className="w-full relative">
            <DitherDivider />

            <div className="mx-auto">
                {/* Centered header */}
                <div className="text-center px-6 md:px-10 lg:px-14 pt-14 md:pt-20 pb-10 border-t border-border">
                    <h3 className="text-3xl font-medium tracking-tighter md:text-4xl">
                        {workflowConnectConfig.title}
                    </h3>
                    <p className="mt-4 text-muted-foreground text-balance max-w-md mx-auto">
                        {workflowConnectConfig.description}
                    </p>
                </div>

                {/* Two-column grid with divider */}
                <div className="grid grid-cols-1 md:grid-cols-2 md:divide-x divide-border border-t border-border">
                    <div className="relative border-b border-border flex flex-col">
                        <CornerPlus position="top-right" className="text-muted-foreground/50 hidden md:block" />
                        <IntegrationBlock popoverPosition="top" />
                        <div className="max-w-xl text-left items-start p-6 pb-14 mt-auto">
                            <p className="text-sm text-muted-foreground flex items-center gap-2 justify-start">
                                {workflowConnectConfig.blocks[0].icon}
                                {workflowConnectConfig.blocks[0].title}
                            </p>
                            <p className="text-base text-foreground leading-relaxed mt-2">
                                {workflowConnectConfig.blocks[0].description}
                            </p>
                        </div>
                    </div>

                    <div className="relative border-b border-border flex flex-col">
                        <CornerPlus position="top-left" className="text-muted-foreground/50 hidden md:block" />
                        <AgentWorkflowBlock />
                        <div className="max-w-xl text-left items-start p-6 pb-14 mt-auto">
                            <p className="text-sm text-muted-foreground flex items-center gap-2 justify-start">
                                {workflowConnectConfig.blocks[1].icon}
                                {workflowConnectConfig.blocks[1].title}
                            </p>
                            <p className="text-base text-foreground leading-relaxed mt-2">
                                {workflowConnectConfig.blocks[1].description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
